import {ChildCaseModel} from '../model/child-case.model';
import {VisitModel} from '../model/visit.model';

export class SymptomsUtil {

    // Edema -------------------------------------------------------------------------------------------------------------------------------
    public static EDEMA = {
        value: 'EDEMA',
        selected: false,
        text: 'Edema',
    };

    public static GENERALIZED_EDEMA = {
        value: 'GENERALIZED_EDEMA',
        selected: false,
        text: 'Edema generalizado',
    };

    public static EDEMA_ON_BOTH_FEET = {
        value: 'EDEMA_ON_BOTH_FEET',
        selected: false,
        text: 'Edema em ambos os pies',
    };
    // Complications -----------------------------------------------------------------------------------------------------------------------
    public static VOMITING = {
        value: 'VOMITING',
        selected: false,
        text: 'Vómitos',
    };

    public static DIARRHEA = {
        value: 'DIARRHEA',
        selected: false,
        text: 'Diarrea',
    };

    public static FEVER = {
        value: 'FEVER',
        selected: false,
        text: 'Fiebre',
    };

    public static SOMNOLENCE = {
        value: 'SOMNOLENCE',
        selected: false,
        text: 'Somnolencia',
    };

    // Appetite ----------------------------------------------------------------------------------------------------------------------------
    public static DOES_NOT_BRING_FOOD_TO_MOUTH = {
        value: 'DOES_NOT_BRING_FOOD_TO_MOUTH',
        selected: false,
        text: 'No lleva la comida a la boca',
    };

    public static DONT_SUCK = {
        value: 'DONT_SUCK',
        selected: false,
        text: 'No chupa',
    };

    public static DONT_SWALLOW = {
        value: 'DONT_SWALLOW',
        selected: false,
        text: 'No traga',
    };

    // Deprecated ----------------------------------------------------------------------------------------------------------------------------
    public static ANOTHER_DISEASE = {
        value: 'ANOTHER_DISEASE',
        selected: false,
        text: 'Otra doença',
    };

    public static OTHER_COMPLICATIONS = {
        value: 'OTHER_COMPLICATIONS',
        selected: false,
        text: 'Otras complicaciones',
    };

    public static HAS_NO_APPETITE = {
        value: 'HAS_NO_APPETITE',
        selected: false,
        text: 'Sem appetite',
    };

    public static SYMPTOM(value: string): string {
        const symptom = this.listSymptoms()
            .find(current => current.value === value)?.text;

        return symptom ? symptom : 'Ninguno';
    }

    public static listSymptoms() {
        return [SymptomsUtil.EDEMA, SymptomsUtil.EDEMA_ON_BOTH_FEET, SymptomsUtil.GENERALIZED_EDEMA,
            SymptomsUtil.VOMITING, SymptomsUtil.DIARRHEA, SymptomsUtil.FEVER, SymptomsUtil.SOMNOLENCE,
            SymptomsUtil.ANOTHER_DISEASE,
            SymptomsUtil.DOES_NOT_BRING_FOOD_TO_MOUTH, SymptomsUtil.DONT_SUCK, SymptomsUtil.DONT_SWALLOW];
    }

    public static edemas() {
        return [SymptomsUtil.EDEMA_ON_BOTH_FEET, SymptomsUtil.GENERALIZED_EDEMA];
    }

    public static complications() {
        return [SymptomsUtil.VOMITING, SymptomsUtil.DIARRHEA, SymptomsUtil.FEVER, SymptomsUtil.SOMNOLENCE];
    }

    public static appetite() {
        return [SymptomsUtil.DOES_NOT_BRING_FOOD_TO_MOUTH, SymptomsUtil.DONT_SUCK, SymptomsUtil.DONT_SWALLOW];
    }

    public static containsGeneralizedEdema(child: ChildCaseModel) {
        return child.symptoms.filter(symptom => SymptomsUtil.GENERALIZED_EDEMA.value == symptom).length > 0;
    }

    public static containsEdemaInBothFeet(child: ChildCaseModel) {
        return child.symptoms.filter(symptom => SymptomsUtil.EDEMA_ON_BOTH_FEET.value == symptom).length > 0;
    }

    public static visitContainsGeneralizedEdema(visit: VisitModel) {
        return visit.symptoms && visit.symptoms.filter(symptom => SymptomsUtil.GENERALIZED_EDEMA.value == symptom).length > 0;
    }

    public static visitContainsEdemaInBothFeet(visit: VisitModel) {
        return visit.symptoms.filter(symptom => SymptomsUtil.EDEMA_ON_BOTH_FEET.value == symptom).length > 0;
    }


    public static haveNoAppetite(child: ChildCaseModel) {
        return SymptomsUtil.appetite().filter(symptom => child.symptoms.includes(symptom.value)).length > 0;
    }

    public static haveComplications(child: ChildCaseModel) {
        return SymptomsUtil.complications().filter(symptom => child.symptoms.includes(symptom.value)).length > 0;
    }

    public static haveNoAppetiteAtVisit(visit: VisitModel) {
        return visit.symptoms.filter(symptom => SymptomsUtil.HAS_NO_APPETITE.value == symptom).length > 0;
    }

    public static haveComplicationsAtVisit(visit: VisitModel) {
        return visit.symptoms.filter(symptom => SymptomsUtil.OTHER_COMPLICATIONS.value == symptom).length > 0;
    }


}
